module.exports = __webpack_public_path__ + "static/stethoscope_mobile-f10c11e58f00dd524d14ffd31e87ac7b.png";